// extracted by mini-css-extract-plugin
export default {"lds-roller":"Loader_lds-roller__73FGZ"};